'use client';

import { renderAppIcon } from '@/components/icons/app-icon-registry';
import { UnifiedTooltip } from '@/components/ui/feedback/notification/unified-tooltip';
import { cn } from '@/lib/ui/utils';
import { type ReactNode, useEffect, useState } from 'react';
import { useWorkspaceIsMobileViewport } from './workspace-viewport';

export function WorkspaceInfoTooltip({
  ariaLabel,
  className,
  icon,
  iconClassName,
  content,
  contentClassName,
  text,
}: {
  ariaLabel?: string;
  className?: string;
  icon?: ReactNode;
  iconClassName?: string;
  content?: ReactNode;
  contentClassName?: string;
  text?: string;
}) {
  const isMobileViewport = useWorkspaceIsMobileViewport();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [isMobileViewport]);

  return (
    <UnifiedTooltip
      align="start"
      open={open}
      onOpenChange={setOpen}
      triggerAsChild
      trigger={
        <button
          type="button"
          className={cn(
            'cms-block-workspace-workspace-1-workspace-form-controls__paramHintTrigger',
            className
          )}
          aria-label={ariaLabel ?? text ?? 'Info'}
          aria-expanded={isMobileViewport ? open : undefined}
          onPointerDown={
            isMobileViewport
              ? (event) => {
                  event.preventDefault();
                }
              : undefined
          }
          onClick={
            isMobileViewport
              ? (event) => {
                  event.preventDefault();
                  setOpen(true);
                }
              : undefined
          }
        >
          {icon ??
            renderAppIcon({
              name: 'circle-help',
              className: cn(
                'cms-block-workspace-workspace-1-workspace-form-controls__paramHintIcon',
                iconClassName
              ),
            })}
        </button>
      }
      content={content}
      text={content ? undefined : text}
      bodyClassName="max-w-72 whitespace-pre-line text-sm leading-6 sm:max-w-80"
      contentClassName={contentClassName ?? 'px-3 py-2.5'}
    />
  );
}
